import React from 'react';

const ArrowIconDown = ({ width = 16, height = 10, fill = "#B1B1B1" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.9999 9.50012C4.7339 9.50012 0.878899 3.26012 0.139899 2.00912C-0.142101 1.53412 0.0158991 0.921119 0.490899 0.640119C0.966899 0.357119 1.5799 0.517119 1.8599 0.991119C3.4149 3.61612 6.4399 7.50012 7.9999 7.50012C9.5619 7.50012 12.5869 3.61612 14.1399 0.991119C14.4209 0.517119 15.0359 0.357119 15.5089 0.640119C15.9839 0.920119 16.1419 1.53312 15.8599 2.00912C15.1209 3.26012 11.2659 9.50012 7.9999 9.50012Z"
      fill={fill}
    />
  </svg>
);

export default ArrowIconDown;